<template>
  <div class="layout-wrapper">
    <div class="layout-main-container">
      <div class="layout-main">
        <div class="grid mb-2" dir="rtl">
          <div class="col-12 md-col .md:col-6 lg:col-6 xl:col-3">
            <div class="card surface-section mb-0">
              <div class="flex justify-content-between mb-3">
                <div>
                  <span class="block  font-medium mb-3">{{ $t('SCORE') }}</span>
                  <div class="text-900 font-medium text-xl">{{ userInfo.score }}</div>
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round"
                  style="width: 2.5rem; height: 2.5rem">
                  <i class="pi pi-check-square text-blue-500 text-xl"></i>
                </div>
              </div>
              <span class="text-green-500 font-medium">إحصائياتي</span>
            </div>
          </div>
          <div class="col-12 md-col .md:col-6 lg:col-6 xl:col-3">
            <div class="card surface-card mb-0">
              <div class="flex justify-content-between mb-3">
                <div>
                  <span class="block  font-medium mb-3">{{ $t('EVALUATION_POINTS') }}</span>
                  <div class="text-900 font-medium text-xl">{{ userInfo.evaluationPoints }}</div>
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round"
                  style="width: 2.5rem; height: 2.5rem">
                  <i class="pi pi-star text-blue-500 text-xl"></i>
                </div>
              </div>
              <span class="text-green-500 font-medium">إحصائياتي</span>
            </div>
          </div>
          <div class="col-12 md-col .md:col-6 lg:col-6 xl:col-3">
            <div class="card surface-section mb-0">
              <div class="flex justify-content-between mb-3">
                <div>
                  <span class="block  font-medium mb-3">{{ $t('REWARDABLE_POINTS') }}</span>
                  <div class="text-900 font-medium text-xl">{{ userInfo.rewardablePoints }}</div>
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round"
                  style="width: 2.5rem; height: 2.5rem">
                  <i class="pi pi-wallet text-blue-500 text-xl"></i>
                </div>
              </div>
              <span class="text-green-500 font-medium">إحصائياتي</span>

            </div>
          </div>
          <div class="col-12 md-col .md:col-6 lg:col-6 xl:col-3 mt-0">
            <div class="card surface-card mb-0">
              <div class="flex justify-content-between mb-3">
                <div>
                  <span class="block . font-medium mb-3">{{ $t('GIFTS_OPERATIONS') }}</span>
                  <div class="text-900 font-medium text-xl">{{ generalStats.giftRequestsCount }}</div>
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round"
                  style="width: 2.5rem; height: 2.5rem">
                  <i class="pi pi-gift text-blue-500 text-xl"></i>
                </div>
              </div>
              <span class="text-green-500 font-medium">إحصائيات عامة</span>
            </div>
          </div>
          <div class="col-12 md-col .md:col-6 lg:col-6 xl:col-3">
            <div class="card surface-section mb-0">
              <div class="flex justify-content-between mb-3">
                <div>
                  <span class="block  font-medium mb-3">{{ $t('BORROWING_OPERATIONS') }}</span>
                  <div class="text-900 font-medium text-xl">{{ generalStats.borrowingRequestsCount
                    }}</div>
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round"
                  style="width: 2.5rem; height: 2.5rem">
                  <i class="pi pi-file-import text-blue-500 text-xl"></i>
                </div>
              </div>
              <span class="text-green-500 font-medium">إحصائيات عامة</span>
            </div>
          </div>
          <div class="col-12 md-col .md:col-6 lg:col-6 xl:col-3">
            <div class="card surface-card mb-0">
              <div class="flex justify-content-between mb-3">
                <div>
                  <span class="block  font-medium mb-3">{{ $t('EXCHANGE_OPERATIONS') }}</span>
                  <div class="text-900 font-medium text-xl">{{ generalStats.exchangeRequestsCount
                    }}</div>
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round"
                  style="width: 2.5rem; height: 2.5rem">
                  <i class="pi pi-sync text-blue-500 text-xl"></i>
                </div>
              </div>
              <span class="text-green-500 font-medium">إحصائيات عامة</span>
            </div>
          </div>
          <div class="col-12 md-col .md:col-6 lg:col-6 xl:col-3">
            <div class="card surface-section mb-0">
              <div class="flex justify-content-between mb-3">
                <div>
                  <span class="block  font-medium mb-3">{{ $t('OWNER_COUNT') }}</span>
                  <div class="text-900 font-medium text-xl">{{ generalStats.userCount }}</div>
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round"
                  style="width: 2.5rem; height: 2.5rem">
                  <i class="pi pi-user text-blue-500 text-xl"></i>
                </div>
              </div>
              <span class="text-green-500 font-medium">إحصائيات عامة</span>

            </div>
          </div>
          <div class="col-12 md-col .md:col-6 lg:col-6 xl:col-3">
            <div class="card surface-card mb-0">
              <div class="flex justify-content-between mb-3">
                <div>
                  <span class="block  font-medium mb-3">{{ $t('BOOKS_COUNT') }}</span>
                  <div class="text-900 font-medium text-xl">{{ generalStats.booksCount }}</div>
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round"
                  style="width: 2.5rem; height: 2.5rem">
                  <i class="pi pi-book text-blue-500 text-xl"></i>
                </div>
              </div>
              <span class="text-green-500 font-medium">إحصائيات عامة</span>
            </div>
          </div>
        </div>
        <div class="card surface-50 mt-3">
          <div class="text-900 text-xl" style="text-align: center;">
            {{ $t('RECENT_OPERATIONS') }}
          </div>
        </div>
        <div class="flex flex-wrap justify-content-center gap-2 mb-2" dir="rtl">
          <div v-for="operation in operations" :key="operation" class="flex-item">
            <Operation :operation="operation" @operationStatusChanged="handleOperationStatusChanged"
              @senderEvaluated="handleSenderEvaluated" @receiverEvaluated="handleReceiverEvaluated"
              @operationErrorOccurred="handleOperationError" @messagesReadMark="handleMessagesReadMark"
              @incidenceRegistered="handleIncidenceRegistered" />
          </div>
          <div v-if="shouldShowEmptyResults()">
            <ErrorLast />
          </div>
        </div>
        <div class="card surface-50 mt-4">
          <div class="text-900 text-xl" style="text-align: center;">
            {{ $t('SOON_ENDING_OPERATIONS') }}
          </div>
        </div>
        <div id="endingOperations" class="flex flex-wrap justify-content-center gap-2 mb-2" dir="rtl">
          <div v-for="operation in mySoonEndingOperations" :key="operation" class="flex-item">
            <Operation :operation="operation" @operationStatusChanged="handleOperationStatusChanged"
              @senderEvaluated="handleSenderEvaluated" @receiverEvaluated="handleReceiverEvaluated"
              @operationErrorOccurred="handleOperationError" @messagesReadMark="handleMessagesReadMark"
              @incidenceRegistered="handleIncidenceRegistered" />
          </div>
          <div v-if="noEndingOperations()">
            <ErrorSoon />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, onBeforeUnmount, onErrorCaptured, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useToast } from "primevue/usetoast"
import { useI18n } from 'vue-i18n'
import { handleError } from '@/helpers/ErrorHandler'
import operationService from '@/service/OperationService'
import statsService from '@/service/StatsService'
import Operation from '@/components/Operation.vue'
import { socketMessageTypeEnum, operationStatusEnum } from '@/helpers/Constants'
import SocketListener from '@/model/SocketListener'
import socketService from '@/service/SocketService'

import userManagementService from '@/service/UserManagementService'
import userService from '@/service/UserService'
import ErrorLast from '@/components/ErrorLast.vue'
import ErrorSoon from '@/components/ErrorSoon.vue'


const operations = ref([])
const mySoonEndingOperations = ref([])
const generalStats = ref({})
const userInfo = ref({})
const authStore = useAuthStore()
const toast = useToast()
const i18n = useI18n()
let uniqueId


onBeforeMount(async () => {
  uniqueId = 'HOME_' + new Date().getTime()
  try {
    let result = await operationService.getMyLastOperations(7)
    operations.value = result.result.collection
    result = await statsService.loadGlobalStats()
    generalStats.value = result.result
    result = await operationService.getMySoonEndingOperations(7)
    mySoonEndingOperations.value = result.result.collection
    socketService.addListener(socketMessageTypeEnum.OPERATION_UPDATE, new SocketListener(uniqueId, handleOperationStatusChange))
    socketService.addListener(socketMessageTypeEnum.CHAT_MESSAGE, new SocketListener(uniqueId, handleInstantMessage))
  } catch (error) {
    handleError(authStore, toast, i18n, error)
  }
})

onMounted(async () => {
    try {
        const response = await userManagementService.getUserInfo()
        userInfo.value = response.result
        userService.calculateRewardablePoints(userInfo.value)
    } catch (error) {
        handleError(authStore, toast, i18n, error)
    }
    // toast.add({ severity: 'info', summary: 'في مكان ما خارج التوتليب في الاندرويد يختفي بدون مشاكل ، ', detail: '', life: 300000000 })
})

onBeforeUnmount(() => {
  socketService.removeListener(uniqueId)
})

onErrorCaptured((err, instance, info) => {
  return handleError(authStore, toast, i18n, err, instance, info)
})

const shouldShowEmptyResults = () => {
  return operations.value === null || operations.value === undefined || operations.value.length === 0
}

const noEndingOperations = () => {
  return mySoonEndingOperations.value === null || mySoonEndingOperations.value === undefined || mySoonEndingOperations.value.length === 0
}

const handleOperationStatusChange = (message) => {
  if (message.newStatusId !== undefined && message.newStatusId !== null) {
    getAllOperations().filter(o => o.id === message.operationId).forEach(o => {
      o.statusId = message.newStatusId
      if (message.newStatusId === operationStatusEnum.COMPLETED) {
        o.daysToExpire = null
      }
    })
  }
}

const handleInstantMessage = (message) => {
  getAllOperations().filter(o => o.id === message.operationId).forEach(o => o.unreadMessages = true)
}

const handleOperationStatusChanged = (operationId, newStatus, feedbackMessage) => {
  getAllOperations().filter(o => o.id === operationId).forEach(o => {
    o.statusId = newStatus
    if (newStatus === operationStatusEnum.COMPLETED) {
      o.daysToExpire = null
    }
  })
  toast.add({ severity: 'info', summary: feedbackMessage, detail: '', life: 3000 })
}

const handleSenderEvaluated = (operationId) => {
  getAllOperations().filter(o => o.id === operationId).forEach(o => o.senderEvaluated = true)
  toast.add({ severity: 'info', summary: i18n.t('USER_EVALUATED'), detail: '', life: 3000 })
}

const handleReceiverEvaluated = (operationId) => {
  getAllOperations().filter(o => o.id === operationId).forEach(o => o.receiverEvaluated = true)
  toast.add({ severity: 'info', summary: i18n.t('USER_EVALUATED'), detail: '', life: 3000 })
}

const handleMessagesReadMark = (operationId) => {
  getAllOperations().filter(o => o.id === operationId).forEach(o => o.unreadMessages = false)
}

const handleOperationError = (e) => {
  handleError(authStore, toast, i18n, e)
}

const handleIncidenceRegistered = (updatedOperation) => {
  toast.add({ severity: 'info', summary: i18n.t('INCIDENCE_REGISTERED'), detail: '', life: 3000 })
  getAllOperations().filter(o => o.id === updatedOperation.id).forEach(o => {
    o.senderIncidence = updatedOperation.senderIncidence
    o.receiverIncidence = updatedOperation.receiverIncidence
  })
}

function getAllOperations() {
  return operations.value.concat(mySoonEndingOperations.value)
}

</script>

<style lang="scss" scoped>
.grid {
  margin-top: -1rem;
}

.card {
  border: 1px solid var(--surface-border);
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: var(--card-shadow);
  border-radius: 12px;

  &:last-child {
    margin-bottom: 0;
  }
}

 @media (max-width: 1200px) and (min-width: 539px) {
    .md-col {
        flex: 0 0 auto;
        padding: 0.5rem;
        width: 50%;
      }
  }

</style>
